module.exports = __webpack_public_path__ + "static/media/kia-plus.35706a72.svg";